export default __webpack_public_path__ + "static/media/ROM EXAM PATTERN 2026-27 (CLASS - 7).a0061cf8.pdf";